module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/rc-animate/~/babel-runtime/core-js/object/set-prototype-of.js
 ** module id = 1333
 ** module chunks = 3
 **/